import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Due to limited capabilities of traditional methods to reflect the depth of experiential qualities associated with spatial hearing, a more advanced custom methodologies have been proposed. One example is ADA method (developed by Dolby [No]) which allows for high-dimensional capture of subjective experiences of sound localization and quality. In this section, one of basic applications of ADA method is presented - evaluation of binaural audio system performance in the context of spatial localization.<br><center><h3>THE ACTUAL LOCATION OF THE STIMULUS</h3></center>",
  layout: {
    type: "simple",
    options: {
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/26/principle/slide6-figure2.svg`,
                  styles: {
                    height: "50%",
                  },
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
